import React, { FC, ReactElement } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material";
import ExploreIcon from "@mui/icons-material/Explore";
import { brandingSettings } from "../branding";
import UserAvatar from "./LeftSidebar/UserAvatar";

interface i_props {
  logoUrl: string;
  onStartJoyRide: () => void;
}

const Navbar: FC<i_props> = ({ logoUrl, onStartJoyRide }): ReactElement => {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor:
          theme.palette.mode === "dark"
            ? brandingSettings.headercolorDark
            : brandingSettings.headercolor,
      }}
    >
      <Toolbar
        sx={{
          minHeight: 48, // navbar height
          height: 48,
          px: 2,
          display: "flex",
          alignItems: "center", // 👈 vertically align items in the middle
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 logo aligns with text
            mr: 2,
          }}
        >
          <img
            src={logoUrl}
            alt="Persistent logo"
            style={{
              height: "40px", // larger than toolbar, but stays centered
              width: "auto",
              display: "block",
              // marginTop: "10px",
            }}
          />
        </Box>

        <Typography
          variant="h6"
          noWrap
          sx={{
            // fontWeight: 800,
            color:
              theme.palette.mode === "dark"
                ? brandingSettings.textcolorPrimaryDark
                : "inherit",
            textDecoration: "none",
            pl: 1, // 👈 small left padding so text doesn't stick to logo
            flex: 1,
            display: "flex",
            alignItems: "center", // align text vertically too
          }}
        >
          Secure Portal
        </Typography>

        <Tooltip title="Start virtual tour">
          <IconButton onClick={onStartJoyRide} size="small">
            <ExploreIcon
              style={{ color: brandingSettings.textcolorSecondaryDark }}
            />
          </IconButton>
        </Tooltip>

        <Box sx={{ ml: 1 }}>
          <UserAvatar />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
